import { SkapaElement } from "@ingka/skapa-webc-element";
const styles = ':host{box-sizing:border-box;display:grid;grid-template-rows:0fr;transition:all var(--skapa-reduced-motion-override,.25s) cubic-bezier(.4,0,.4,1)}.content{overflow:hidden}:host([expanded]){grid-template-rows:1fr}@media (prefers-reduced-motion){:host{--skapa-reduced-motion-override:0ms}}';
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <div class="content">
      <slot></slot>
    </div>
  `;
  return { main: template };
}
class Collapsible extends SkapaElement {
  constructor() {
    super();
    this.updateState = () => {
      if (this.expanded && this.fullyClosed) {
        this.content.toggleAttribute("hidden", false);
      }
      this.setAttribute("aria-hidden", `${!this.expanded}`);
    };
    this.handleTransitionEnd = (e) => {
      if (e.target !== this && e.propertyName !== "grid-template-rows") {
        return;
      }
      this.content.toggleAttribute("hidden", !this.expanded);
    };
    this.gatherProperties(["expanded"], this);
    const shadow = this.shadow = this.attachShadow({ mode: "open" });
    const templates = this.getTemplates(generateTemplate);
    shadow.append(templates.main.content.cloneNode(true));
    this.animating = false;
    this.fullyClosed = !this.expanded;
    this.content = this.shadow.querySelector(".content");
  }
  static get observedAttributes() {
    return ["expanded"];
  }
  connectedCallback() {
    super.connectedCallback();
    this.shadow.addEventListener("slotchange", this.updateState);
    this.addEventListener("transitionend", this.handleTransitionEnd);
    this.setAttribute("aria-hidden", `${!this.expanded}`);
    this.content.toggleAttribute("hidden", !this.expanded);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.shadow.removeEventListener("slotchange", this.updateState);
  }
  attributeChangedCallback() {
    if (this.isConnected) {
      this.updateState();
    }
  }
  get expanded() {
    return this.hasAttribute("expanded");
  }
  set expanded(value) {
    this.toggleAttribute("expanded", !!value);
  }
}
Collapsible.skapaTagName = "collapsible";
Collapsible.skapaDependencies = [];
var Collapsible_default = Collapsible;
export {
  Collapsible,
  Collapsible_default as default
};
